
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SaasHero from '@/components/saas/landing/SaasHero';
import SaasHowItWorks from '@/components/saas/landing/SaasHowItWorks';
import PointsSystem from '@/components/saas/landing/sections/PointsSystem';
import SaasFeatures from '@/components/saas/landing/SaasFeatures';
import SaasCallToAction from '@/components/saas/landing/SaasCallToAction';
import VideoHeader from '@/components/saas/landing/VideoHeader';
import SEO from '@/components/SEO';

const SaasLanding: React.FC = () => {
  return (
    <>
      <SEO 
        title="ReferMe SaaS | White-Label Referral Program Platform"
        description="Launch your own white-labeled referral program in minutes. Scale your business with our enterprise-grade referral platform."
        keywords="white label referral program, saas referral platform, referral software, enterprise referral program"
      />
      <div className="min-h-screen flex flex-col">
        <Header isLoggedIn={false} />
        <main className="flex-grow">
          <VideoHeader />
          <SaasHero />
          <SaasHowItWorks />
          <PointsSystem />
          <SaasFeatures />
          <SaasCallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default SaasLanding;
